/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const useGetOnlineMeeting = (id, hash, queryParams) => {
  return useQuery({
    queryKey: queryKeys.onlineMeeting.detail(id, hash),
    queryFn: () => fetcher({ method: "GET", url: `/public/online-meeting/item/id/${id}/hash/${hash}` }),
    ...queryParams,
  });
};
